// URLs
export const providerApiInternal = 'http://localhost:3001';
export const AUTH_URL = 'http://dev.accounts.cebroker.com';
export const PROVIDER_SUITE_URL = 'http://dev.providers.cebroker.com';
export const HOME_URL = 'http://dev.cebroker.com';
export const LAUNCHPAD_URL = 'http://dev.launchpad.cebroker.com';

// Export all
export default {
  providerApiInternal,
  AUTH_URL,
  PROVIDER_SUITE_URL,
  HOME_URL,
  LAUNCHPAD_URL,
};



// WEBPACK FOOTER //
// ./src/config/dev.config.js